import React, { useState, useEffect } from 'react';
import { Calendar, Clock, CheckCircle } from 'lucide-react';

const API = 'https://talentflow-backend-production-09dd.up.railway.app/api';

export default function VendorSchedule({ token }) {
  const [candidates, setCandidates] = useState([]);
  const [loading, setLoading] = useState(true);
  const [confirming, setConfirming] = useState(null);
  const [done, setDone] = useState(null);
  const [msg, setMsg] = useState('');
  const [showModal, setShowModal] = useState(null);
  const [reason, setReason] = useState('');
  const [actionLoading, setActionLoading] = useState(false);

  useEffect(() => { loadCandidates(); }, []);

  const handleAction = async (candidateId, action) => {
    setActionLoading(true);
    try {
      const r = await fetch(`${API}/candidates/${candidateId}/${action}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
        body: JSON.stringify({ reason })
      });
      const d = await r.json();
      if (d.success) {
        setMsg(action === 'reschedule' ? '🔄 Interview rescheduled! Client has been notified to select new slots.' : '❌ Interview cancelled!');
        setShowModal(null);
        setReason('');
        loadCandidates();
      }
    } catch {}
    setActionLoading(false);
  };

  const loadCandidates = async () => {
    try {
      const r = await fetch(`${API}/candidates/my-scheduled`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      const d = await r.json();
      if (d.success) setCandidates(d.candidates || []);
    } catch {}
    setLoading(false);
  };

  const confirmSlot = async (candidateId, slot) => {
    setConfirming(candidateId);
    try {
      const r = await fetch(`${API}/candidates/${candidateId}/confirm-slot`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
        body: JSON.stringify({ slot })
      });
      const d = await r.json();
      if (d.success) {
        setDone(candidateId);
        setMsg('✅ Slot confirmed! All parties notified. Redirecting to schedule meeting...');
        loadCandidates();
        // Calendly pe redirect karo
        if (d.meetingLink) {
          setTimeout(() => {
            window.open(d.meetingLink, '_blank');
          }, 1500);
        }
      }
    } catch {}
    setConfirming(null);
  };

  if (loading) return <div style={{textAlign:'center',padding:'60px',color:'#94a3b8'}}>Loading...</div>;

  const pending = candidates.filter(c => c.scheduleStatus === 'pending_vendor');
  const confirmed = candidates.filter(c => c.scheduleStatus === 'confirmed');

  return (
    <div>
      {msg && <div style={{padding:'12px 16px',background:'#dcfce7',color:'#16a34a',borderRadius:'8px',marginBottom:'16px',fontSize:'14px'}}>{msg}</div>}

      {/* Pending Slots */}
      {pending.length > 0 && (
        <div style={{marginBottom:'28px'}}>
          <h3 style={{color:'#1e293b',fontSize:'15px',fontWeight:'600',margin:'0 0 16px',display:'flex',alignItems:'center',gap:'8px'}}>
            <span style={{width:'8px',height:'8px',borderRadius:'50%',background:'#f59e0b',display:'inline-block'}}/>
            Pending Confirmation ({pending.length})
          </h3>
          <div style={{display:'grid',gap:'16px'}}>
            {pending.map(c => (
              <div key={c._id} style={{background:'white',borderRadius:'12px',padding:'24px',border:'2px solid #fde68a',boxShadow:'0 1px 4px rgba(0,0,0,0.04)'}}>
                <div style={{display:'flex',justifyContent:'space-between',alignItems:'flex-start',marginBottom:'16px'}}>
                  <div>
                    <h4 style={{color:'#1e293b',fontSize:'16px',fontWeight:'700',margin:'0 0 4px'}}>{c.name}</h4>
                    <p style={{color:'#64748b',fontSize:'13px',margin:0}}>For: {c.requirement?.title}</p>
                  </div>
                  <span style={{padding:'4px 12px',background:'#fef9c3',color:'#ca8a04',borderRadius:'20px',fontSize:'11px',fontWeight:'700'}}>PENDING</span>
                </div>

                <div style={{background:'#f8fafc',borderRadius:'8px',padding:'14px',marginBottom:'16px',border:'1px solid #e2e8f0'}}>
                  <div style={{display:'flex',alignItems:'center',gap:'6px',color:'#64748b',fontSize:'13px',marginBottom:'8px'}}>
                    <Calendar size={14}/> <strong>Date:</strong> {c.interviewDate}
                  </div>
                  <div style={{color:'#64748b',fontSize:'13px',fontWeight:'600',marginBottom:'8px'}}>
                    <Clock size={14} style={{verticalAlign:'middle',marginRight:'4px'}}/> Available Slots:
                  </div>
                  <div style={{display:'grid',gap:'8px'}}>
                    {(c.interviewSlots || []).map(slot => (
                      <div key={slot} style={{display:'flex',justifyContent:'space-between',alignItems:'center',padding:'10px 14px',background:'white',borderRadius:'8px',border:'1px solid #e2e8f0'}}>
                        <span style={{color:'#1e293b',fontWeight:'600',fontSize:'14px'}}>⏰ {slot}</span>
                        <button onClick={() => confirmSlot(c._id, slot)} disabled={confirming===c._id}
                          style={{padding:'6px 16px',background:'#0f172a',color:'white',border:'none',borderRadius:'6px',cursor:'pointer',fontSize:'12px',fontWeight:'600',fontFamily:'inherit'}}>
                          {confirming===c._id ? 'Confirming...' : 'Confirm This Slot'}
                        </button>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}

      {/* Confirmed Slots */}
      {confirmed.length > 0 && (
        <div>
          <h3 style={{color:'#1e293b',fontSize:'15px',fontWeight:'600',margin:'0 0 16px',display:'flex',alignItems:'center',gap:'8px'}}>
            <CheckCircle size={16} color="#16a34a"/>
            Confirmed Interviews ({confirmed.length})
          </h3>
          <div style={{display:'grid',gap:'12px'}}>
            {confirmed.map(c => (
              <div key={c._id} style={{background:'white',borderRadius:'12px',padding:'20px',border:'1px solid #86efac',boxShadow:'0 1px 4px rgba(0,0,0,0.04)'}}>
                <div style={{display:'flex',justifyContent:'space-between',alignItems:'center'}}>
                  <div>
                    <h4 style={{color:'#1e293b',fontSize:'15px',fontWeight:'700',margin:'0 0 4px'}}>{c.name}</h4>
                    <p style={{color:'#64748b',fontSize:'13px',margin:'0 0 8px'}}>For: {c.requirement?.title}</p>
                    <div style={{display:'flex',gap:'16px'}}>
                      <span style={{color:'#64748b',fontSize:'13px'}}><Calendar size={13} style={{verticalAlign:'middle'}}/> {c.interviewDate}</span>
                      <span style={{color:'#6366f1',fontWeight:'600',fontSize:'13px'}}>⏰ {c.confirmedSlot}</span>
                  </div>
                  {c.meetingLink && <a href={c.meetingLink} target="_blank" rel="noreferrer" style={{display:'inline-flex',alignItems:'center',gap:'6px',padding:'8px 16px',background:'#0f172a',color:'white',borderRadius:'6px',textDecoration:'none',fontSize:'12px',fontWeight:'500',marginTop:'8px',marginRight:'8px'}}>🎯 Join Interview</a>}
                  <button onClick={()=>setShowModal({id:c._id,action:'reschedule'})} style={{padding:'8px 14px',background:'white',color:'#374151',border:'1px solid #e5e7eb',borderRadius:'8px',cursor:'pointer',fontSize:'12px',fontWeight:'600',fontFamily:'inherit',marginTop:'10px',marginRight:'8px'}}>🔄 Reschedule</button>
                  <button onClick={()=>setShowModal({id:c._id,action:'cancel'})} style={{padding:'8px 14px',background:'white',color:'#dc2626',border:'1px solid #fecaca',borderRadius:'8px',cursor:'pointer',fontSize:'12px',fontWeight:'600',fontFamily:'inherit',marginTop:'10px'}}>❌ Cancel</button>
                </div>
                <span style={{padding:'4px 12px',background:'#dcfce7',color:'#16a34a',borderRadius:'20px',fontSize:'11px',fontWeight:'700'}}>CONFIRMED</span>
              </div>
              </div>
            ))}
          </div>
        </div>
      )}

      {pending.length === 0 && confirmed.length === 0 && (
        <div style={{textAlign:'center',padding:'60px',background:'white',borderRadius:'12px',border:'1px solid #e2e8f0',color:'#94a3b8'}}>
          <Calendar size={40} color="#e2e8f0" style={{margin:'0 auto 12px',display:'block'}}/>
          <p style={{margin:0,fontSize:'15px'}}>No interview slots to confirm yet</p>
          <p style={{margin:'8px 0 0',fontSize:'13px'}}>When clients send slots, they will appear here</p>
        </div>
      )}
    {showModal && (
      <div style={{position:'fixed',inset:0,background:'rgba(0,0,0,0.5)',zIndex:200,display:'flex',alignItems:'center',justifyContent:'center',padding:'20px'}}>
        <div style={{background:'white',borderRadius:'16px',padding:'32px',maxWidth:'400px',width:'100%',boxShadow:'0 40px 80px rgba(0,0,0,0.2)'}}>
          <h3 style={{color:'#1e293b',fontSize:'18px',fontWeight:'700',margin:'0 0 8px'}}>{showModal.action==='reschedule'?'🔄 Reschedule Interview':'❌ Cancel Interview'}</h3>
          <p style={{color:'#64748b',fontSize:'13px',margin:'0 0 16px'}}>{showModal.action==='reschedule'?'Client ko naye slots select karne honge.':'Yeh action permanent hai. Client aur Admin ko notify kiya jayega.'}</p>
          <div style={{marginBottom:'20px'}}>
            <label style={{color:'#64748b',fontSize:'12px',fontWeight:'600',display:'block',marginBottom:'6px'}}>REASON *</label>
            <textarea value={reason} onChange={e=>setReason(e.target.value)} placeholder="Reason batao..." style={{width:'100%',padding:'10px',border:'1px solid #e2e8f0',borderRadius:'8px',fontSize:'13px',outline:'none',resize:'none',height:'80px',boxSizing:'border-box',fontFamily:'inherit'}}/>
          </div>
          <div style={{display:'flex',gap:'10px'}}>
            <button onClick={()=>{setShowModal(null);setReason('');}} style={{flex:1,padding:'11px',background:'#f1f5f9',color:'#64748b',border:'none',borderRadius:'8px',cursor:'pointer',fontFamily:'inherit',fontWeight:'600'}}>Cancel</button>
            <button onClick={()=>handleAction(showModal.id,showModal.action)} disabled={!reason||actionLoading}
              style={{flex:1,padding:'11px',background:showModal.action==='reschedule'?'linear-gradient(135deg,#f59e0b,#d97706)':'linear-gradient(135deg,#ef4444,#dc2626)',color:'white',border:'none',borderRadius:'8px',cursor:'pointer',fontFamily:'inherit',fontWeight:'600',opacity:!reason?0.5:1}}>
              {actionLoading?'Processing...':(showModal.action==='reschedule'?'🔄 Reschedule':'❌ Cancel')}
            </button>
          </div>
        </div>
      </div>
    )}
    </div>
  );
}
